// extracted by mini-css-extract-plugin
export default {"skeleton-tabs":"kA9HM3","skeleton-tabs_size_m":"lqfsD8","skeleton-tabs_size_s":"vTZ5BL"};